import React, { useEffect, useState } from "react";
import {Row, Col, Card, CardBody, Button} from "reactstrap";
import { httpGet} from "../../common/petitions";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './model.json';
import "./tables.scss";
import "./Puestos.scss";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom';

const Repu_lub_llan = () => {
  const [data, setData] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('03');
  const navigate = useNavigate();
  // const [rubro, setRubro] = useState();
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet(`/repuestoslub/desgloce/20232024`, navigate);
      const jsonData = { "columns": Models.headers, "rows": rowsData };
      setData(jsonData);
      filterData(filter, jsonData); // Initially filter data after fetching
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };

  const filterData = (filterValue, originalData) => {
    setFilter(filterValue);
    if (filterValue) {
      const filteredRows = originalData.rows.filter(row => row.idgrupo === filterValue)
      setFilteredData({ ...originalData, rows: filteredRows })
    } else {
      setFilteredData(originalData)
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const options = {
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };

  document.title = "Rubros - Repuestos llantas y lubricantes - IPG";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Rubros" title="Repuestos llantas y lubricantes" />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Button color="primary" onClick={() => filterData('03', data)} className="me-2">Llantas</Button>
                  <Button color="primary" onClick={() => filterData('11', data)} className="me-2">Lubricantes</Button>
                  <Button color="primary" onClick={() => filterData('12', data)} className="me-2">Repuestos</Button>
                  <DataLoader 
                    isLoading={isLoading} 
                    data={filteredData} 
                    options={options}
                    rubro={"materiales"}
                    reload={fetchData}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Repu_lub_llan;
